import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { action, computed, observable } from 'mobx';
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';

@BindAll()
export class BusinessAddressController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: false,
      pagination: EnumAPI.business_findAddressList,
      details: EnumAPI.business_findAddressById,
      insert: EnumAPI.business_addOrUpdateAddress,
      update: EnumAPI.business_addOrUpdateAddress,
      delete: EnumAPI.business_deleteAddress,
      paginationParams: {
        response: {
          valueGetter: this.valueGetter,
        },
      },
    });
  }
  private valueGetter(response) {
    const addressList = lodash.get(response, 'addressList');
    const dataSource = lodash.map(addressList, (item, index: any) => {
      let isDefault;
      if (this.selectAddress && this.selectAddress[this.distributorCode]) {
        isDefault = lodash.eq(
          item.id,
          this.selectAddress[this.distributorCode].id,
        );
      } else {
        isDefault = index == 0;
      }
      return lodash.merge(item, {
        isDefault: isDefault,
        name: item.consignee,
        tel: item.mobile,
        address: lodash
          .compact([
            lodash.get(item, 'provinceName'),
            lodash.get(item, 'cityName'),
            lodash.get(item, 'countyName'),
            lodash.get(item, 'details'),
          ])
          .join(' / '),
      });
    });
    return {
      isIncludeSign: lodash.get(response, 'isIncludeSign'),
      dataSource,
    };
  }
  @observable
  distributorCode = '';

  @action.bound
  setDistributorCode(val) {
    this.distributorCode = val;
  }
  /**
   * @desc BPP 收货地址
   */
  @computed
  get BppDataSource() {
    return lodash.filter(this.dataSource, ['source', 'BPP-SMB']);
  }
  /**
   * @desc Sec 收货地址
   */
  @computed
  get SecDataSource() {
    return lodash.filter(this.dataSource, ['source', 'SEC']);
  }
  @computed
  get isIncludeSign(): boolean {
    return this.Pagination.Model.getStorage('response.isIncludeSign', false);
  }
  @computed
  public get selectAddress() {
    return (
      this.Details.Model.getStorage('selectAddress', {
        [this.distributorCode]: this.Pagination.firstData,
      }) || {}
    );
  }

  onSelectAddress(address) {
    lodash.each(this.dataSource, (item: any) => {
      item.isDefault = lodash.eq(item.id, address.id);
    });

    const selectAddress = this.Details.Model.getStorage('selectAddress');
    if (selectAddress) {
      this.Details.Model.setStorage(
        'selectAddress',
        lodash.merge(selectAddress, {
          [this.distributorCode]: address,
        }),
      );
    } else {
      this.Details.Model.setStorage('selectAddress', {
        [this.distributorCode]: address,
      });
    }
  }
}
